module.exports = __webpack_public_path__ + "img/brand (8).530b101d.svg";